import { MouseEventHandler, useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from '@mui/material';
import { BackArrowIcon } from 'assets/icons';
import Image from 'components/medias/Image';
import useStyles from './BackButton.styles';
import { shareContext } from '../ShareContext';

type BackButtonPureProps = {
  onClick: MouseEventHandler;
};

const BackButtonPure = ({ onClick }: BackButtonPureProps): JSX.Element => {
  const classes = useStyles();

  return (
    <Button
      className={classes.button}
      data-testid="back-button"
      onClick={onClick}
    >
      <Image className={classes.image} src={BackArrowIcon} />
      &nbsp;
      <FormattedMessage id="button.back" />
    </Button>
  );
};

const BackButton = (): JSX.Element => {
  const { setSelectedFolder } = useContext(shareContext);
  return <BackButtonPure onClick={() => setSelectedFolder(undefined)} />;
};

export default BackButton;
